module.exports = __webpack_public_path__ + "3da39e0ac6a4bab5426a445f3c5dd54a.jpg";